export abstract class GraphHumanumRoutes {
    static Attendance = 'attendance';
    static Progress = 'progress';
    static OwnProgress = 'own-progress';
}
